// Module
var code = "<input class=\"form-control input-sm date-picker full-width\" date-range-picker name=\"{{vm.name}}\" ng-if=\"vm.isLoaded\" ng-model=\"vm.model\" options=\"vm.options\" type=\"text\"/>";
// Exports
module.exports = code;